import { translations } from '../i18n';

/**
 * Ce qu'il faut savoir avant que l'application ne soit montée.
 *
 * Ces deux fonctions servent l'écran d'erreur affiché quand la configuration
 * du domaine n'a pas pu être chargée — donc avant LanguageProvider, et hors
 * de portée de useTranslation. Elles ne dépendent que de sources locales :
 * le bundle, le stockage du navigateur, et navigator.languages.
 */

const MANUAL_LANG_KEY = 'cabazaManualLanguage';

/**
 * Un hôte .eu qui n'est ni www ni admin peut porter une application autonome.
 *
 * On ne le sait avec certitude qu'après la réponse de l'API — mais on le sait
 * AVANT elle, ce qui suffit à décider si un échec de chargement doit être
 * bloquant. Sur la plateforme, un repli reste légitime ; sur une adresse
 * d'app, il ferait fuiter le périmètre.
 *
 * @param {string} hostname
 * @returns {boolean}
 */
export function hotePeutEtreApp(hostname) {
    if (!hostname) return false;
    if (!/\.cabaza\.eu$/i.test(hostname)) return false;
    return !/^(www|admin)\./i.test(hostname);
}

/**
 * Résout les libellés de l'écran d'erreur sans passer par LanguageContext.
 *
 * Les deux sources — choix manuel enregistré, langue du navigateur — restent
 * disponibles même API éteinte : les traductions sont dans le bundle.
 *
 * @param {string|null} langueManuelle - Choix enregistré, s'il existe
 * @param {string[]} languesNavigateur - navigator.languages
 * @returns {object} Les libellés de la section appError
 */
export function resoudreAppError(langueManuelle, languesNavigateur) {
    const candidates = [];

    if (langueManuelle) {
        candidates.push(String(langueManuelle).toLowerCase());
    }
    (languesNavigateur || []).forEach((l) => {
        if (l) candidates.push(String(l).split('-')[0].toLowerCase());
    });

    for (const code of candidates) {
        const section = translations[code]?.appError;
        if (section) return section;
    }

    // L'anglais avant le français : c'est la langue pivot des applications,
    // et la cible du repli des sous-domaines.
    return translations.en?.appError || translations.fr.appError;
}

/**
 * Même chose, en lisant l'environnement réel.
 */
export function libellesAppError() {
    let manuelle = null;
    try {
        manuelle = localStorage.getItem(MANUAL_LANG_KEY);
    } catch (e) {
        // Stockage indisponible : on se rabat sur le navigateur.
    }

    const navLangs = (typeof navigator !== 'undefined')
        ? (navigator.languages || [navigator.language])
        : [];

    return resoudreAppError(manuelle, navLangs);
}
